/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Storytelling
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'gemini/dashboard/glass/controllers/OpenActionHandler'
], function (BaseClass) {
	var ActionHandler = BaseClass.extend({

		_getTargetPerspective: function () {
			return Promise.resolve('story');
		},

		_hasValidTags: function(item) {
			const tags = item.tags || [];
			return tags.includes('story');
		}
	});
	return ActionHandler;
});
